var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.23 0c.34 0 .615.275.615.615V4.46c0 1.4-.99 2.574-2.307 2.857v7.818c0 .34-.276.615-.616.615-.34 0-.615-.275-.615-.615V7.317C1.99 7.034 1 5.861 1 4.46V.615C1 .275 1.275 0 1.615 0c.34 0 .615.275.615.615V4.46c0 .933.76 1.692 1.692 1.692.933 0 1.692-.759 1.692-1.692V.615c0-.34.276-.615.615-.615zm6.029 0c.82 0 1.59.583 2.17 1.641.471.858.752 1.912.752 2.82 0 1.4-.99 2.573-2.307 2.856v7.818c0 .34-.275.615-.615.615-.34 0-.615-.275-.615-.615V7.317c-1.317-.283-2.307-1.456-2.307-2.857 0-.907.28-1.961.751-2.819C10.668.583 11.44 0 12.26 0zm0 1.23c-.334 0-.753.385-1.092 1.003-.37.674-.6 1.528-.6 2.227 0 .933.76 1.692 1.692 1.692.933 0 1.692-.759 1.692-1.692 0-.7-.23-1.553-.6-2.227-.34-.618-.758-1.003-1.092-1.003zM3.922 0c.34 0 .616.275.616.615v3.753c0 .34-.276.615-.616.615-.34 0-.615-.275-.615-.615V.615c0-.34.276-.615.615-.615z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDining);
export default __webpack_public_path__ + "static/media/dining.cefde5fd61ee2a64f71cdb1f3b39a2d0.svg";
export { ForwardRef as ReactComponent };